import { Box, Stack, Typography } from "@mui/material";

import { MarketplaceQuantityControl } from "./MarketplaceQuantityControl";
import { formatWooPrice } from "../utils/addressHelpers";
import { marketplaceTypography as mt } from "../constants/marketplaceTypography";
import {
  marketplaceLineItemImageSx,
  marketplaceLineItemRowSx,
} from "../constants/marketplaceCardStyles";

interface MarketplaceLineItemRowProps {
  name: string;
  price: number;
  quantity: number;
  imageSrc?: string;
  editable?: boolean;
  stockLimit?: number | null;
  canIncrease?: boolean;
  disabled?: boolean;
  badge?: string;
  onChangeQuantity?: (quantity: number) => void;
  currencyCode?: string;
}

/** Row reutilizável para carrinho e pedidos. */
export function MarketplaceLineItemRow({
  name,
  price,
  quantity,
  imageSrc,
  editable = false,
  stockLimit = null,
  canIncrease = true,
  disabled = false,
  badge,
  onChangeQuantity,
  currencyCode = "BRL",
}: MarketplaceLineItemRowProps) {
  return (
    <Stack direction="row" spacing={1.5} sx={marketplaceLineItemRowSx}>
      {imageSrc ? (
        <Box component="img" src={imageSrc} alt={name} sx={marketplaceLineItemImageSx} />
      ) : (
        <Box sx={marketplaceLineItemImageSx} />
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap">
          <Typography
            sx={{
              ...mt.bodySecondary,
              fontWeight: 600,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {name}
          </Typography>
          {badge ? (
            <Typography
              component="span"
              sx={{ ...mt.bodySecondary, color: "warning.dark", fontWeight: 700, fontSize: "0.8125rem" }}
            >
              {badge}
            </Typography>
          ) : null}
        </Stack>
        <Typography sx={{ ...mt.bodySecondary, color: "text.secondary", mt: 0.25 }}>
          {formatWooPrice(price, currencyCode)} · unidade
        </Typography>
        {editable && onChangeQuantity ? (
          <Box sx={{ mt: 1 }}>
            <MarketplaceQuantityControl
              quantity={quantity}
              stockLimit={stockLimit}
              disabled={disabled}
              canIncrease={canIncrease}
              onChange={onChangeQuantity}
            />
          </Box>
        ) : (
          <Typography sx={{ ...mt.bodySecondary, mt: 0.75 }}>Quantidade: {quantity}</Typography>
        )}
      </Box>
    </Stack>
  );
}
